(() => {
  if (window.OneShotAnatomia) {
    window.OneShotAnatomia.initAll();
    return;
  }

  const AUTO_INTERVAL = 6500;
  const INTERACTION_PAUSE = 12000;
  const MAX_AUTO_PASSES = 12;
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initSection = (section) => {
    if (section.dataset.anatomiaInitialized === 'true') return;

    const card = section.querySelector('.oneshot-anatomia__card');
    const number = section.querySelector('[data-anatomia-number]');
    const title = section.querySelector('[data-anatomia-title]');
    const description = section.querySelector('[data-anatomia-description]');
    const hotspots = [...section.querySelectorAll('.oneshot-anatomia__hotspot[data-anatomia-index]')];
    const rows = [...section.querySelectorAll('.oneshot-anatomia__list [data-anatomia-index]')];
    const cycleToggle = section.querySelector('[data-anatomia-cycle-toggle]');

    if (!card || !number || !title || !description || !hotspots.length || !rows.length) return;

    section.dataset.anatomiaInitialized = 'true';

    let current = -1;
    let autoPasses = 0;
    let autoTimer = null;
    let resumeTimer = null;
    let animationTimer = null;
    let inView = false;
    let manuallyPaused = false;
    let interactionCooldown = false;

    const stopAuto = () => {
      if (autoTimer !== null) {
        window.clearInterval(autoTimer);
        autoTimer = null;
      }
    };

    const canRunAutomatically = () => (
      !motionQuery.matches
      && !manuallyPaused
      && !interactionCooldown
      && inView
      && !document.hidden
      && autoPasses < MAX_AUTO_PASSES
    );

    const show = (index, animate = true) => {
      const row = rows[index];
      if (!row || index === current) return;

      current = index;
      hotspots.forEach((hotspot, itemIndex) => {
        hotspot.setAttribute('aria-pressed', String(itemIndex === index));
      });
      rows.forEach((item, itemIndex) => {
        item.setAttribute('aria-pressed', String(itemIndex === index));
      });

      number.textContent = row.dataset.number || '';
      title.textContent = row.dataset.title || '';
      description.textContent = row.dataset.description || '';

      if (animate && !motionQuery.matches) {
        window.clearTimeout(animationTimer);
        card.classList.remove('is-swapping');
        void card.offsetWidth;
        card.classList.add('is-swapping');
        animationTimer = window.setTimeout(() => card.classList.remove('is-swapping'), 420);
      }
    };

    const startAuto = () => {
      if (autoTimer !== null || !canRunAutomatically()) return;

      autoTimer = window.setInterval(() => {
        if (!canRunAutomatically()) {
          stopAuto();
          return;
        }

        show((current + 1) % rows.length);
        autoPasses += 1;

        if (autoPasses >= MAX_AUTO_PASSES) stopAuto();
      }, AUTO_INTERVAL);
    };

    const pauseAfterInteraction = () => {
      stopAuto();
      window.clearTimeout(resumeTimer);
      autoPasses = 0;
      interactionCooldown = true;
      resumeTimer = window.setTimeout(() => {
        interactionCooldown = false;
        startAuto();
      }, INTERACTION_PAUSE);
    };

    const activateFromControl = (control) => {
      const index = Number.parseInt(control.dataset.anatomiaIndex, 10);
      if (Number.isNaN(index)) return;
      pauseAfterInteraction();
      show(index);
    };

    [...hotspots, ...rows].forEach((control) => {
      control.addEventListener('pointerenter', () => activateFromControl(control));
      control.addEventListener('focus', () => activateFromControl(control));
      control.addEventListener('click', () => activateFromControl(control));
    });

    if (cycleToggle) {
      cycleToggle.addEventListener('click', () => {
        manuallyPaused = !manuallyPaused;
        cycleToggle.setAttribute('aria-pressed', String(manuallyPaused));
        cycleToggle.textContent = manuallyPaused ? 'Riprendi il ciclo' : 'Ferma il ciclo';

        window.clearTimeout(resumeTimer);
        interactionCooldown = false;

        if (manuallyPaused) {
          stopAuto();
        } else {
          autoPasses = 0;
          startAuto();
        }
      });
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        inView = entry.isIntersecting;
        section.classList.toggle('is-live', inView && !motionQuery.matches);
        if (inView) startAuto();
        else stopAuto();
      });
    }, { threshold: 0.05 });

    const onVisibilityChange = () => {
      if (document.hidden) stopAuto();
      else startAuto();
    };

    const onMotionChange = () => {
      section.classList.toggle('is-live', inView && !motionQuery.matches);
      if (motionQuery.matches) stopAuto();
      else startAuto();
    };

    observer.observe(section);
    document.addEventListener('visibilitychange', onVisibilityChange);
    if (motionQuery.addEventListener) motionQuery.addEventListener('change', onMotionChange);
    else motionQuery.addListener(onMotionChange);

    show(0, false);

    section._oneshotAnatomiaCleanup = () => {
      stopAuto();
      window.clearTimeout(resumeTimer);
      window.clearTimeout(animationTimer);
      observer.disconnect();
      document.removeEventListener('visibilitychange', onVisibilityChange);
      if (motionQuery.removeEventListener) motionQuery.removeEventListener('change', onMotionChange);
      else motionQuery.removeListener(onMotionChange);
    };
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-oneshot-anatomia]')) initSection(scope);
    scope.querySelectorAll?.('[data-oneshot-anatomia]').forEach(initSection);
  };

  window.OneShotAnatomia = { initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.matches?.('[data-oneshot-anatomia]')
      ? event.target
      : event.target.querySelector?.('[data-oneshot-anatomia]');
    section?._oneshotAnatomiaCleanup?.();
  });
})();
